module.exports = __webpack_public_path__ + "img/route-marker-direction.f20b33ab.svg";